import { types as t } from 'mobx-state-tree';
import FacetValue from './FacetValue';

const Facet = t.model("Facet", {
	DisplayName: t.string,
	Name: t.string,
    FacetValues: t.optional(t.array(FacetValue), []),
    IsSizeFacet: t.optional(t.boolean, false),
    IsOpen: t.optional(t.boolean,false),
    IsFilter: t.optional(t.boolean, false),
    Dirty: t.optional(t.boolean, false)// Set if toggled	
}).views(self => ({

})).actions(self => ({

}));


export default Facet;